<template>
  <div :class="isCollapsed ? 'flex justify-center' : ''">
    <div class="relative">
      <input
        type="text"
        :placeholder="isCollapsed ? '' : $t('Поиск')"
        v-model="searchQuery"
        class="input"
        :class="[isCollapsed ? 'short' : 'full']"
      />
      <svg-icon
        name="sli-search"
        class="icon"
        :class="[isCollapsed ? 'icon--collapsed' : '']"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    isCollapsed: {
      type: Boolean,
    },
  },
  emits: ["search"],
  data() {
    return {
      searchQuery: "",
    };
  },
  watch: {
    searchQuery(val) {
      this.$emit("search", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  @apply py-2 p-1 focus:outline-none;
  @apply placeholder:font-medium;
  @apply rounded-md border border-border bg-card text-sm;
  @apply focus:ring-1 focus:ring-foreground;
  height: 36px;
  padding: 0 8px;
  will-change: width;
  transition: width 0.3s ease;
  &::placeholder {
    @apply text-muted-foreground text-sm;
  }
}

.icon {
  @apply absolute pointer-events-none w-4 h-4 text-muted-foreground;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}

.icon--collapsed {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.full {
  width: 100%;
  padding-left: 32px;
}
.short {
  width: 34px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
